import styled from 'styled-components';

const SubTitleWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const LeftColumn = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

export { LeftColumn, SubTitleWrapper };
